export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0308.b4bb122.webp";